export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./picUpload.vue?vue&type=template&id=18ac34f9&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/picUpload.vue?vue&type=template&id=18ac34f9&scoped=true&
// module id = null
// module chunks = 